import type { ReactNode } from 'react';
import { useLocation } from '@tanstack/react-router';

import { useScreenEntrance } from '../../lib/motion/hooks';

/**
 * Wraps the page so each new screen rises in, leaning from the side of the
 * tab it came from. Same page, same render: nothing moves.
 */
export function ScreenEntrance({ order, children }: { order: readonly string[]; children: ReactNode }) {
  const { pathname } = useLocation();
  const entrance = useScreenEntrance(pathname, order);
  return (
    <div className="screen-enter" data-enter={entrance.direction} data-enter-key={entrance.key}>
      {children}
    </div>
  );
}
